import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { VelocityTransitionGroup } from 'velocity-react';
import { TranslatedCopy } from '../intl/TranslatedCopy';
import { Button, Icon } from '../components';
import Input from '~COMPONENTS/formInputs/Input';
import Spinner from '~COMPONENTS/spinner/Spinner';

import { slideDownIn, slideUpOut } from '../animation/util';

const AddressAutocomplete = ({ foundAddresses, displayHandler, populateFields, isPending, ...props }) => (
  <>
    <div className='u-full-width mb2-sm'>
      <div className='addressAutocomplete__section u-full-width'>
        <div className='addressAutocomplete__section_input u-full-width'>
          <Input {...props} />
        </div>
        <div className='addressAutocomplete__section_spinner'>{isPending && <Spinner />}</div>
      </div>
      <div className='u-full-width mt2-sm'>
        <VelocityTransitionGroup enter={slideDownIn} leave={slideUpOut}>
          {foundAddresses.length > 0 && (
            <div className='addressAutocomplete u-full-width border-grey bg-white text-color-secondary'>
              <div className='u-full-width pt2-sm prl2-sm'>
                <em>
                  <TranslatedCopy id='checkout.shipping.address.autocomplete.suggestions' />
                </em>
                <Button className='responsive-display-2-1 fl-sm-r' onClick={displayHandler}>
                  <Icon name='x' alt='close icon' />
                </Button>
              </div>
              {foundAddresses.map(address => (
                <div
                  key={address.Id}
                  className='addressAutocomplete__address p2-sm'
                  onClick={() => populateFields(address)}
                >
                  {address.Text}
                  {address.Description}
                </div>
              ))}
            </div>
          )}
        </VelocityTransitionGroup>
      </div>
    </div>
  </>
);

AddressAutocomplete.propTypes = {
  foundAddresses: PropTypes.array.isRequired,
  displayHandler: PropTypes.func.isRequired,
  populateFields: PropTypes.func.isRequired,
  isPending: PropTypes.bool.isRequired
};

export default AddressAutocomplete;
